import { useCallback } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection } from "lexical";
import { $patchStyleText } from "@lexical/selection";


const useTextEditor = () => {
    const [editor] = useLexicalComposerContext();

    const applyStyleText = useCallback(
        (styles: Record<string, string>) => {
            editor.update(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    $patchStyleText(selection, styles);
                }
            });
        },
        [editor],
    );

    const onFontSizeSelect = useCallback(
        (value: string) => {
            applyStyleText({ 'font-size': value });
        },
        [applyStyleText],
    );

    const onFontLineSelect = useCallback(
        (value: string) => {
            applyStyleText({ 'line-height': value });
        },
        [applyStyleText],
    );

    return {
        onFontSizeSelect,
        onFontLineSelect,
    };
};

export default useTextEditor;
